export const getActiveGoalsCount = goals => goals.filter(({ status }) => status === 'Active').length;

export const getGoalsOptionText = ({
  goal,
  none,
  plural,
  singular,
}) => {
  const { goals, name } = goal;
  const count = getActiveGoalsCount(goals);

  if (count === 0) {
    return `${name} (${none})`;
  }

  if (count === 1) {
    return `${name} (${count} ${singular})`;
  }

  return `${name} (${count} ${plural})`;
};
